import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import ResponsiveGrid from "../grid/responsiveGrid";

import { CustomPagination } from "../customPagination";

import { DEGRADED_COLOR, DEGRADED_OUTAGE_COLOR, FAILURE_COLOR, getNameFromHimsSystem, ONLINE_COLOR } from "./hmsUtil";
import { ConvertISOToDate } from "../util";

import { useUserAuth } from "../contexts/authContext";

const HimsSystemHistoryDialog = ({ system, systemHistoryDialogOpen, setSystemHistoryDialogOpen }) => {
    const [systemHistoryData, setSystemHistoryData] = useState([]);
    const [sortModel, setSortModel] = useState([{ field: "date_reported", sort: "desc" }]);

    const { handleFailedFetch } = useUserAuth();

    const historyColumns = [
        {
            field: "date_reported",
            headerName: "Date Reported",
            flex: 1,
            valueGetter: (value) => ConvertISOToDate(value)
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1
        },
        {
            field: "min_in_status",
            headerName: "Min in Status",
            flex: 1,
            maxWidth: 125
        }
    ];

    useEffect(() => {
        fetchSystemHistory();
    }, []);

    const fetchSystemHistory = () => {
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ system_uuid: system.system_uuid })
        };
        fetch("api/hms/system/history", requestOptions)
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then((data) => {
                let lastDate = dayjs();
                data.forEach((row) => {
                    row.min_in_status = lastDate.diff(row.date_reported, "minutes");
                    lastDate = dayjs(row.date_reported);
                });
                setSystemHistoryData(data);
            })
            .catch((err) => handleFailedFetch(err));
    };
    return (
        <Dialog open={systemHistoryDialogOpen} onClose={() => setSystemHistoryDialogOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>{`${getNameFromHimsSystem(system)} History`}</DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        marginTop: "5px",
                        "& .failure": { backgroundColor: FAILURE_COLOR },
                        "& .degraded_outage": { backgroundColor: DEGRADED_OUTAGE_COLOR },
                        "& .degraded": { backgroundColor: DEGRADED_COLOR },
                        "& .nominal": { backgroundColor: ONLINE_COLOR }
                    }}
                >
                    <ResponsiveGrid
                        disableVirtualization
                        autoHeight
                        rows={systemHistoryData}
                        columns={historyColumns}
                        disableRowSelectionOnClick
                        rowHeight={30}
                        headerHeight={40}
                        getRowId={(row) => row.date_reported}
                        pagination
                        slots={{ pagination: CustomPagination }}
                        initialState={{ pagination: { paginationModel: { pageSize: 22 } } }}
                        getCellClassName={(params) => {
                            if (params.field === "status") {
                                return params.value.toLowerCase();
                            }
                            return "";
                        }}
                        sx={{ bgcolor: "#121212" }}
                        sortModel={sortModel}
                        onSortModelChange={(model) => setSortModel(model)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setSystemHistoryDialogOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default HimsSystemHistoryDialog;
